import React, { useState } from "react";
import { Link, useSearchParams } from "react-router-dom";
import { useTranslation } from 'react-i18next';
import api from "../../services/api";
import { useForm } from "react-hook-form";
import toast from "react-hot-toast";

import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import {
  Card,
  CardHeader,
  CardTitle,
  CardDescription,
  CardContent,
  CardFooter,
} from "@/components/ui/card";
import { Separator } from "@/components/ui/separator";

const ResetPassword = () => {
  const { t } = useTranslation();
  const {
    register,
    handleSubmit,
    reset,
    formState: { errors },
  } = useForm({
    defaultValues: {
      email: "",
    },
    mode: "onTouched",
  });

  const [loading, setLoading] = useState(false);
  const [searchParams] = useSearchParams();

  const handleResetPassword = async (data) => {
    const { password } = data;

    const token = searchParams.get("token");

    setLoading(true);
    try {

      await api.post("/auth/public/reset-password", {
        token,
		password
      });
      toast.success(t('resetPassword_successMessage'));
      reset();
    } catch (error) {
      toast.error(t('resetPassword_errorMessage'));
    } finally {
      setLoading(false);
    }
  };

  return (
  <div className="min-h-[calc(100vh-74px)] flex items-center justify-center">
    <Card className="w-[360px] sm:w-[450px] shadow-custom">
      <form onSubmit={handleSubmit(handleResetPassword)}>
        <CardHeader className="text-center">
          <CardTitle className="text-2xl font-bold">
            {t('resetPassword_title')}
          </CardTitle>
          <CardDescription>
            {t('resetPassword_subtitle')}
          </CardDescription>
        </CardHeader>

        <Separator />

        <CardContent className="pt-6 space-y-4">
          <div className="space-y-2">
            <Label htmlFor="password">{t('resetPassword_passwordLabel')}</Label>
            <Input
              id="password"
              type="password"
              placeholder={t('resetPassword_passwordPlaceholder')}
              {...register("password", { required: true, minLength: 6 })}
            />
            {errors?.password && (
              <p className="text-sm text-red-500">
                {t('resetPassword_passwordError')}
              </p>
            )}
          </div>
        </CardContent>

        <CardFooter className="flex flex-col gap-3">
          <Button type="submit" disabled={loading} className="w-full">
            {loading ? t('resetPassword_submitButtonLoading') : t('resetPassword_submitButton')}
          </Button>

          <p className="text-sm text-slate-700 text-center">
            <Link to="/login" className="underline hover:text-black">
              {t('resetPassword_backToLogin')}
            </Link>
          </p>
        </CardFooter>
      </form>
    </Card>
  </div>
);

};

export default ResetPassword;
